import React from 'react';
import './Home.css';
import Avatar from '../../assets/Images/profile.jpg'


const Home = () => {
    return (
        <section id="home">
            <div className="home-text" data-aos="fade-down">
                <strong>Hello, It's me</strong>
                <h1>Barath</h1>
                <p>Highly passionate individual with strong leadership and communication abilities. A dedicated team player who is excited about experiencing industrial exposures.</p>
                <a href="#summary" className='btn-link'>Scroll for Me</a>
            </div>

            <div className='home-img' data-aos="fade-up">
                <div className='img-box'>
                    <img src={Avatar} alt="Avatar" />
                    <h2>Barath<br /><span>Software Engineer</span></h2>

                    <div className='social'>
                        <a href='https://www.facebook.com/barath.gowribalakurukkal'>
                            <i className="fa-brands fa-facebook"></i>
                        </a>

                        <a href='www.linkedin.com/in/sribarathvajasarma-gowribalakurukkal-58bb561a4'>
                            <i className="fa-brands fa-linkedin"></i>
                        </a>
                    </div>
                    <a href="mailto:gsribarathvajasarma@gmail.com" className='hire-me'>Hire Me</a>
                </div>

            </div>

        </section>
    )
}

export default Home